import { render, staticRenderFns } from "./indexChartItemTitle.vue?vue&type=template&id=10912723&scoped=true&"
import script from "./indexChartItemTitle.vue?vue&type=script&lang=js&"
export * from "./indexChartItemTitle.vue?vue&type=script&lang=js&"
import style0 from "./indexChartItemTitle.vue?vue&type=style&index=0&id=10912723&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10912723",
  null
  
)

export default component.exports